import React from 'react';
import { PropTypes } from 'prop-types';
import SelectFancy from '@atoms/SelectFancy';

const getDayOptions = () => {
    let day = 1;
    const options = [];
    while (day <= 31) {
        const fullDay = day < 10 ? `0${day}` : `${day}`;
        options.push({ label: day, value: `${fullDay}` });
        day += 1;
    }

    return options;
};

const SelectDay = ({ hideLabel, id, isDisabled, placeholder = '-- Select --', name, label = 'Day' }) => {
    const options = getDayOptions();

    return (
        <SelectFancy
            hideLabel={hideLabel}
            isDisabled={isDisabled}
            id={id}
            label={label}
            name={name}
            options={options}
            placeholder={placeholder}
        />
    );
};

SelectDay.propTypes = {
    hideLabel: PropTypes.bool,
    id: PropTypes.string,
    isDisabled: PropTypes.bool,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
};

export default SelectDay;
